import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./ga";

export default function usePageViewTracking() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
}
